<template>
  <v-container fluid>
    <div v-if="view == 'today' || view == 'all'" class="grid-container">
      <h2>
        {{ $t("dash.visit.planned.today") }}
        {{ $t("dash.visit.planned.planned") }} ({{
          $moment().format("DD MMM")
        }})
      </h2>
      <div class="grid" v-if="today && today.length > 0">
        <div
          v-for="patient in today"
          v-bind:key="patient.id"
        >
          <VisitCard
            :patient="patient"
            :visit="patient.visits[patient.visits.length - 1]"
          />
        </div>
      </div>
      <div v-else>
        <p>{{ $t("dash.visit.planned.not-found") }}</p>
      </div>
    </div>

    <div v-if="view == 'tomorrow' || view == 'all'" class="grid-container">
      <h2>
        {{ $t("dash.visit.planned.tomorrow") }}
        {{ $t("dash.visit.planned.planned") }} ({{
          $moment()
            .add(1, "d")
            .format("DD MMM")
        }})
      </h2>
      <div class="grid" v-if="tomorrow && tomorrow.length > 0">
        <div
          v-for="patient in tomorrow"
          v-bind:key="patient.id"
        >
          <VisitCard
            :patient="patient"
            :visit="patient.visits[patient.visits.length - 1]"
          />
        </div>
      </div>
      <div v-else>
        <p>{{ $t("dash.visit.planned.not-found") }}</p>
      </div>
    </div>

    <div v-if="later && later.length > 0 && view == 'all'" class="grid-container">
      <h2>
        {{ $t("dash.visit.planned.later") }}
        {{ $t("dash.visit.planned.planned") }}
      </h2>
      <div class="grid">
        <div
          v-for="patient in later"
          v-bind:key="patient.id"
        >
          <VisitCard
            later
            :patient="patient"
            :visit="patient.visits[patient.visits.length - 1]"
          />
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import {neoparentPatients} from "@/api";

export default {
  name: "neoparent-visits",
  data() {
    return {
      view: new URL(window.location).searchParams.get("view"),
      today: null,
      tomorrow: null,
      later: null
    };
  },
  watch: {
    view: function() {
      this.getPatientsWithVisit();
    }
  },
  mounted() {
    this.getPatientsWithVisit();
    // Fetch patients/visits every 10min = 600 000ms
    this.timer = setInterval(this.fetchPatientsWithVisit, 600000);
  },
  methods: {
    async getPatientsWithVisit() {
      try {
        neoparentPatients.getAllPatientsForHospital(this.$store.getters.user.hospital.id)
          .then(response => {
            // All patients who have visits
            this.patients = response.data.patients.filter(
              p =>
                !p.isArchived &&
                !p.isDeceased &&
                p.visits &&
                p.visits.length > 0 &&
                  p.visits.map(v => this.$moment(v.dateTime) >= this.$moment())
                    .length > 0
            );

            this.today = this.patients.filter(p => {
              console.log(this.$moment(p.visits[p.visits.length - 1].dateTime))
              // Check for today's visits
              return this.$moment().startOf('day').isSame(
                this.$moment(p.visits[p.visits.length - 1].dateTime).startOf('day'),
                "day"
              );
            });
            this.tomorrow = this.patients.filter(p => {
              // Check for tomorrow's visits
              return (
                this.$moment().startOf('day').diff(
                  this.$moment(p.visits[p.visits.length - 1].dateTime).startOf('day'),
                  "days"
                ) === -1
              );
            });
            this.later = this.patients.filter(p => {
              // Check for later visits
              return (
                this.$moment().startOf('day').diff(
                  this.$moment(p.visits[p.visits.length - 1].dateTime).startOf('day'),
                  "days"
                ) <= -2
              );
            });
            this.loading = false;

            this.later.sort(function(a,b) {
              return new Date(a.visits[0].dateTime) - new Date(b.visits[0].dateTime)
            })
          });



      } catch (e) {
        this.error = e.response.data.message;
      }
    },
    selectPatient(patient) {
      // try {
      //   patient.languages = ["be", "fr"];
      //   await this.$session.set("patient", patient);
      //   this.$router.push({ name: "Patients_Posts" });
      // } catch (error) {
      //   this.consoleLog(error);
      // }
    }
  }
};
</script>

<style scoped lang="scss">
.grid-container {
  padding-bottom: 5rem;

  h2 {
    width: 90%;
    text-align: left;
    margin: 2rem auto;
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, 35rem);
    justify-content: start;
    grid-gap: 2rem;
    width: 90%;
    margin: 48px auto;
    @media (max-width: 40rem) {
      grid-template-columns: 1fr;
    }
  }
}
</style>
